import type { IconNode } from '../types';

/**
 * @name soccer-ball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNMTEuOSA2LjdzLTMgMS4zLTUgMy42YzAgMCAwIDMuNiAxLjkgNS45IDAgMCAzLjEuNyA2LjIgMCAwIDAgMS45LTIuMyAxLjktNS45IDAgLjEtMi0yLjMtNS0zLjYiIC8+CiAgPHBhdGggZD0iTTExLjkgNi43VjIiIC8+CiAgPHBhdGggZD0iTTE2LjkgMTAuNHMzLTEuNCA0LjUtMS42IiAvPgogIDxwYXRoIGQ9Ik0xNSAxNi4zczEuOSAyLjcgMi45IDMuNyIgLz4KICA8cGF0aCBkPSJNOC44IDE2LjNTNi45IDE5IDYgMjAiIC8+CiAgPHBhdGggZD0iTTIuNiA4LjdDNCA5IDcgMTAuNCA3IDEwLjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/soccer-ball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const soccerBall: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  [
    'path',
    {
      d: 'M11.9 6.7s-3 1.3-5 3.6c0 0 0 3.6 1.9 5.9 0 0 3.1.7 6.2 0 0 0 1.9-2.3 1.9-5.9 0 .1-2-2.3-5-3.6',
      key: '1mg18b',
    },
  ],
  ['path', { d: 'M11.9 6.7V2', key: '1t12cm' }],
  ['path', { d: 'M16.9 10.4s3-1.4 4.5-1.6', key: '8aq2q9' }],
  ['path', { d: 'M15 16.3s1.9 2.7 2.9 3.7', key: 'volqrc' }],
  ['path', { d: 'M8.8 16.3S6.9 19 6 20', key: '1atvv1' }],
  ['path', { d: 'M2.6 8.7C4 9 7 10.4 7 10.4', key: '1uixp3' }],
];

export default soccerBall;
